import { css } from '@emotion/css';
import React, { PropsWithChildren } from 'react';
import Authorize from './Users/Authorize';

const pageClassName = (backgroundColor?: string) =>
  css({
    backgroundColor: backgroundColor ?? 'lavender',
    minHeight: '100vh',
    overflowX: 'hidden',
  });

interface Props {
  backgroundColor?: string;
}

const Page: React.FC<PropsWithChildren<Props>> = ({
  children,
  backgroundColor,
}) => (
  <div className={pageClassName(backgroundColor)}>
    <Authorize>{children}</Authorize>
  </div>
);

export default Page;
